import styled from 'styled-components';

export const ServicesContainer = styled.div`
  height: 800px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to right, #4FA0FF , #0E1111); /* Split background into two colors */
  color: white; /* Text color (optional, for contrast) */
  padding: 20px; 
  @media screen and (max-width: 768px) {
    height: 1100px;
  }

  @media screen and (max-width: 480px) {
    height: 1300px;
  }
`;


export const ServicesWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 16px;
  padding: 16px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

export const ServicesCard = styled.button`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 240px;
  width: 280px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    box-shadow: 0 4px 8px 0 rgba(222, 235, 255, 2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

`;
export const ServicesCardCert = styled.button`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 240px;
  width: 280px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    box-shadow: 0 4px 8px 0 rgba(79, 160, 255, 2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
    `;
    export const ServicesCardWait = styled.button`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 240px;
  width: 280px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    box-shadow: 0 4px 8px 0 rgba(158, 85, 207, 2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
    `;
export const ServiceButton = styled.button`
  background: #101522;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
   max-height: 240px;
  width: 280px;
  padding:40px;
 
  color: #ffffff;

`;

export const Img = styled.img`
  width: 300px;
 
`;

export const ServicesIcon = styled.img`
  height: 160px;
  width: 160px;
  margin-bottom: 10px;
`;
export const WaitIcon = styled.img`
  height: 160px;
  width: 160px;
  margin-bottom: 10px;
  border-radius: 15px;
`;
export const ServicesH1 = styled.h1`
  font-size: 1.5rem;
  justify-content: left;
  color: #fff;
   text-shadow: 
   1px 1px 0 black, 
    -1px -1px 0 black, 
    1px -1px 0 black, 
    -1px 1px 0 black; 
  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const ServicesH2 = styled.h2`
  font-size: 1rem;
  margin-bottom: 10px;
`;

export const ServicesP = styled.p`
padding-top: 100px; 
font-size: 1rem;
  text-align: left;
  color: #ffffff;
`;

export const ModalH = styled.h1`
 padding-top:20px;
font-size: 1.8rem;
text-align: center;
  color: #ffffff;
  
`;
export const ModalP = styled.p`
 
font-size: 1.5rem;
  text-align: left;
  color: #ffffff;

   @media (max-width: 480px) {
    /* Apply styles for screens with a maximum width of 480px (typical phone portrait) */
    font-size: 1rem;
  }
`;
export const ModalIcon = styled.img`
  
height: 250px;
  width: 250px;
  margin-bottom: 10px;
  @media (max-width: 480px) {
    height: 100px;
  width: 100px;
  
  }
`;
export const ModalWrapper = styled.div`

height: 300px;

display: grid;
grid-template-columns: 1fr .5fr ;
align-items: center;
grid-gap: 16px;
padding: 16px;

  background: #262626;
  width:800px;
  border-radius: 10px;
  @media (max-width: 480px) {
    /* Apply styles for screens with a maximum width of 480px (typical phone portrait) */
    
    grid-template-columns: 1fr; /* Adjust grid layout for smaller screens */
    padding: 10px; /* Reduce padding */
    width:250px;
  }
`;
export const ModalContainer = styled.div`

flex-direction: row;
background: #262626;
  align-items: center;
  border-radius: 10px;
  
`;
export const ModalButton = styled.button`
display: block;
width: 100%;
padding: 10px;

background-color: #01bf71;
color: #fff;
border: none;
border-radius: 4px;
&:hover {
 
  background-color: #4FA3AB;
  cursor: pointer;
 
}
`